import React, { useState } from "react";

import Community from "../assets/Community.jpg";
import Empowerment from "../assets/Empowerment.jpg";
import Group from "../assets/Group.jpg";
import Honoring from "../assets/Honoring.jpg";
import Nurturing from "../assets/Nurturing.jpg";
import Ecan from "../assets/ecan.jpg";
import Grace from "../assets/grace.jpg";
import Photo from "../assets/photo.jpeg";

function GallerySection() {
  const [, setHoveredId] = useState(null);

  // Use static image URLs for the gallery
  const galleryItems = [
    { src: Community, alt: "Community" },
    { src: Empowerment, alt: "Empowerment" },
    { src: Group, alt: "Group" },
    { src: Honoring, alt: "Honoring" },
    { src: Nurturing, alt: "Nurturing" },
    { src: Ecan, alt: "Ecan" },
    { src: Grace, alt: "Grace" },
    { src: Photo, alt: "Photo" },
    { src: Community, alt: "Community 2" },
    { src: Empowerment, alt: "Empowerment 2" },
    { src: Group, alt: "Group 2" },
    { src: Honoring, alt: "Honoring 2" },
  ];

  return (
    <div className="bg-gradient-to-br from-slate-950 via-slate-900 to-black text-white min-h-screen overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&display=swap');

        * {
          font-family: 'Space Mono', monospace;
        }

        /* Animated Background */
        .animated-bg {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 0;
        }

        .orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.3;
        }

        .orb-1 {
          width: 300px;
          height: 300px;
          background: radial-gradient(circle, rgba(34,197,94,0.8), transparent);
          animation: float1 15s ease-in-out infinite;
          top: -100px;
          left: -100px;
        }

        .orb-2 {
          width: 250px;
          height: 250px;
          background: radial-gradient(circle, rgba(59,130,246,0.6), transparent);
          animation: float2 18s ease-in-out infinite;
          top: 50%;
          right: -50px;
        }

        .orb-3 {
          width: 280px;
          height: 280px;
          background: radial-gradient(circle, rgba(168,85,247,0.5), transparent);
          animation: float3 20s ease-in-out infinite;
          bottom: -100px;
          left: 20%;
        }

        @keyframes float1 {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(30px, -30px); }
        }

        @keyframes float2 {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(-40px, 40px); }
        }

        @keyframes float3 {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(20px, 20px); }
        }

        /* Gallery Grid */
        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 24px;
          perspective: 1000px;
        }

        .gallery-item {
          position: relative;
          height: 350px;
          cursor: pointer;
          border-radius: 20px;
          overflow: hidden;
          background: linear-gradient(135deg, rgba(34,197,94,0.1), rgba(59,130,246,0.1));
          border: 1px solid rgba(34,197,94,0.2);
          transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
        }

        .gallery-item:hover {
          transform: translateY(-12px) scale(1.02);
          border-color: rgba(34,197,94,0.6);
          box-shadow: 0 25px 60px rgba(34,197,94,0.25),
                      inset 0 1px 0 rgba(255,255,255,0.1);
        }

        .gallery-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s cubic-bezier(0.23, 1, 0.32, 1);
          filter: brightness(0.85);
        }

        .gallery-item:hover .gallery-img {
          transform: scale(1.12) rotate(1deg);
          filter: brightness(1.1) contrast(1.15);
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(34,197,94,0.3), rgba(59,130,246,0.2));
          opacity: 0;
          transition: opacity 0.4s ease;
        }

        .gallery-item:hover .overlay {
          opacity: 1;
        }

        .shine {
          position: absolute;
          top: -100%;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%);
          transform: rotate(45deg);
          animation: shine 0.6s ease;
        }

        @keyframes shine {
          to {
            top: 100%;
            left: 100%;
          }
        }

        .gallery-item:hover .shine {
          animation: shine 0.6s ease;
        }

        /* Stagger animation */
        .gallery-item {
          opacity: 0;
          animation: fadeInScale 0.6s cubic-bezier(0.23, 1, 0.32, 1) forwards;
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9) translateY(30px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        .gallery-item:nth-child(1) { animation-delay: 0.1s; }
        .gallery-item:nth-child(2) { animation-delay: 0.2s; }
        .gallery-item:nth-child(3) { animation-delay: 0.3s; }
        .gallery-item:nth-child(4) { animation-delay: 0.2s; }
        .gallery-item:nth-child(5) { animation-delay: 0.3s; }
        .gallery-item:nth-child(6) { animation-delay: 0.4s; }
        .gallery-item:nth-child(7) { animation-delay: 0.3s; }
        .gallery-item:nth-child(8) { animation-delay: 0.4s; }
        .gallery-item:nth-child(9) { animation-delay: 0.5s; }

        /* Navigation */
        nav {
          backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(34,197,94,0.1);
        }

        /* Title Animation */
        .title {
          background: linear-gradient(135deg, #22c55e, #10b981, #3b82f6);
          background-size: 200% 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: gradientShift 6s ease infinite;
        }

        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
      `}</style>

      {/* Animated Background */}
      <div className="animated-bg">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
      </div>
      {/* Second Row of 6 Gallery Cards */}

      {/* Gallery Section */}
      <section className="relative pt-32 pb-20 px-4 z-10">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-6xl md:text-7xl font-black mb-4 text-center title">
            Gallery
          </h2>
          <p className="text-center text-gray-400 mb-16 font-light text-lg">
            Explore my latest work and projects
          </p>
          <div className="w-full h-72 md:h-96 mb-2 flex items-center justify-center relative">
            <img
              src={Group}
              alt="Banner top"
              className="w-full h-full object-cover rounded-xl shadow-lg min-h-[120px] max-h-72 sm:max-h-80 md:max-h-96"
              style={{ objectPosition: "center" }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent rounded-xl"></div>
          </div>
          <div className="gallery-grid">
            {galleryItems.map((item, idx) => (
              <div
                key={idx}
                className="gallery-item"
                onMouseEnter={() => setHoveredId(idx)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <img src={item.src} alt={item.alt} className="gallery-img" />
                <div className="overlay"></div>
                <div className="shine"></div>
              </div>
            ))}
          </div>
          {/* <div className="w-full h-72 md:h-96 mb-12 flex items-center justify-center relative">
            <img
              src={Group}
              alt="Banner Bottom"
              className="w-full h-full object-cover rounded-xl shadow-lg"
              style={{ objectPosition: "center" }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent rounded-xl"></div>
          </div> */}
        </div>
      </section>
    </div>
  );
}

export default GallerySection;
